<template>
  <div class='indexbox'>
    <div class="searchbox">
      <div class="headerbox">

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="val.shop_name" :name="val.id_tostrign" v-for="val in tablist" :key="val.shop_name">
          </el-tab-pane>
        </el-tabs>
        <div class="topbtnbox">
          <el-button v-hasPermi="['settings']" type="primary" @click.native.prevent="onSubmit()" :loading='btn_loading'>
            {{ $t('lg.保存') }}</el-button>
        </div>
      </div>
      <div class="tablebox" v-loading='loading'>
        <el-form ref="forms" :model="form" :rules="rules" class="formbox">
          <el-row :gutter="40">
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="warehouse_id">
                <span class="form_tit">{{ $t('lg.默认发货仓库') }}</span>
                <el-select v-model="form.warehouse_id" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in warehouse" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="refund_warehouse_id">
                <span class="form_tit">{{ $t('lg.默认退货仓库') }}</span>
                <el-select v-model="form.refund_warehouse_id" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in refund_warehouse" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="salesman_id">
                <span class="form_tit">{{ $t('lg.默认销售员') }}</span>
                <el-select v-model="form.salesman_id" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in salesman" :key="item.ContactID" :label="item.Name" :value="item.ContactID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="customer_id">
                <span class="form_tit">{{ $t('lg.默认客户') }}</span>
                <el-select v-model="form.customer_id" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in customer" :key="item.ID" :label="item.Name" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="tax_id">
                <span class="form_tit">{{ $t('lg.默认税率') }}</span>
                <el-select v-model="form.tax_id" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in tax_rate" :key="item.ID" :label="item.Name" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="pay_account_code">
                <span class="form_tit">{{ $t('lg.默认收款退款账户') }}</span>
                <el-select v-model="form.pay_account_code" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in pay_account" :key="item.Code" :label="item.DisplayName" :value="item.Code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="revenue_account_code">
                <span class="form_tit">{{ $t('lg.默认销售收入科目') }}</span>
                <el-select v-model="form.revenue_account_code" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in revenue_account" :key="item.Code" :label="item.DisplayName"
                    :value="item.Code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="express_sale_tax_rule_id">
                <span class="form_tit">{{ $t('lg.服务费商品映射') }}</span>
                <el-select v-model="form.express_sale_tax_rule_id" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in express_good" :key="item.ID" :label="item.express_goods" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="delivery_process">
                <span class="form_tit">{{ $t('lg.发货处理方式') }}</span>
                <el-select v-model="form.delivery_process" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in delivery_process" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="orders_to_dear">
                <span class="form_tit">{{ $t('lg.订单自动同步') }}</span>
                <el-select v-model="form.orders_to_dear" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in orders_to_dear" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="order_start_time">
                <span class="form_tit">{{ $t('lg.自动同步订单的起始日期') }}</span>
                <el-date-picker v-model="form.order_start_time" format='yyyy/MM/dd' value-format='yyyy/MM/dd'
                  type="date" :placeholder="$t('lg.选择日期')">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs='24' :sm='12' :md='8'>

              <el-form-item prop="pick_pack">
                <span class="form_tit">{{ $t('lg.自动PICKPACK') }}</span>
                <el-select v-model="form.pick_pack" filterable :placeholder="$t('lg.请选择')"
                  :disabled="isPickPackDisabled">
                  <el-option v-for="item in pick_pack" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>


            </el-col>

            <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="cny_rate">
                <span class="form_tit">{{ $t('lg.CNY汇率') }}</span>
                <el-input v-model="form.cny_rate" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs='24' :sm='12' :md='8'>
              <div style="display: flex;justify-content: space-between; align-items: center;">
                <el-form-item prop="stock_to_erp" style="flex: 1;">
                  <span class="form_tit">{{ $t('lg.库存自动同步') }}</span>
                  <el-select v-model="form.stock_to_erp" filterable :placeholder="$t('lg.请选择')">
                    <el-option v-for="item in stock_to_erp" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-button v-hasPermi="['settings']" type="primary" @click.native.prevent="save()"
                  :loading='btn_loading' style="margin-bottom: 30px;margin-left: 15px;">
                  {{ $t('lg.同步所有库存') }}
                </el-button>
              </div>

            </el-col>


            <!-- <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item prop="order_header">
                <span class="form_tit">{{$t('lg.订单表头字段')}}</span>
                <el-select v-model="form.order_header" filterable :placeholder="$t('lg.请选择')">
                  <el-option v-for="item in order_header" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item>
                <p style="width:100%;height:40px;"></p>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :xs='24' :sm='12' :md='8'>
              <el-form-item class="btnbox">
                <el-button type="primary" @click.native.prevent="onSubmit()" :loading='btn_loading'>{{$t('lg.保存')}}</el-button>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
      isPickPackDisabled() {
        // 只有当 delivery_process === 1 时才允许编辑
        return this.form.delivery_process !== 1;
      }
    },
    data() {
      return {
        tablist: [],
        activeName: '',
        loading: false,
        form: {
          warehouse: '',
          warehouse_id: '',
          warehouse_key: '',

          refund_warehouse: '',
          refund_warehouse_id: '',
          refund_warehouse_key: '',

          salesman: '',
          salesman_id: '',

          customer_name: '',
          customer_id: '',
          tax_rate: '',
          tax_id: '',
          pay_account: '',
          pay_account_code: '',
          order_header: '',
          delivery_process: '',
          orders_to_dear: '',
          stock_to_erp: '',
          order_start_time: '',
          express_goods: '',
          express_sale_tax_rule_id: '',
          express_sale_tax_rule: '',
          revenue_account: '',
          revenue_account_code: '',
          cny_rate: '',
          pick_pack: '',
        },
        rules: {
          warehouse_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          refund_warehouse_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          salesman_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          customer_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          tax_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          pay_account_code: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          order_header: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          delivery_process: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          orders_to_dear: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          stock_to_erp: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          pick_pack: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          order_start_time: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          express_sale_tax_rule_id: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          revenue_account_code: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          cny_rate: [
            { required: true, trigger: "blur", message: this.$t('lg.请输入') }
          ],
        },
        warehouse: [],
        refund_warehouse: [],
        salesman: [],
        customer: [],
        tax_rate: [],
        pay_account: [],
        order_header: [],
        delivery_process: [
          { name: this.$t('lg.不处理'), id: 0 },
          { name: this.$t('lg.从DEAR推送发货状态到平台'), id: 1 },
          { name: this.$t('lg.从平台获取发货状态到DEAR'), id: 2 },
        ],
        orders_to_dear: [
          { id: 0, name: this.$t('lg.否') },
          { id: 1, name: this.$t('lg.是') }
        ],
        stock_to_erp: [
          { id: 0, name: this.$t('lg.否') },
          { id: 1, name: this.$t('lg.是') }
        ],
        pick_pack: [
          { id: 0, name: this.$t('lg.否') },
          { id: 1, name: this.$t('lg.是') }
        ],
        express_good: [],
        revenue_account: [],
        btn_loading: false,
      };
    },
    watch: {
      'form.delivery_process'(newVal) {
        if (newVal !== 1) {
          this.$set(this.form, 'pick_pack', 0); // 强制设为“否”
        }
      }
    },
    methods: {
      // tab 店铺
      gettablist() {
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            page: 1,
            page_size: 1000,
            api_id: this.api_id,
          },
          success: (res) => {
            res.data.data.forEach(item => {
              item.id_tostrign = item.id.toString()
            });
            this.tablist = res.data.data
            if (this.tablist.length > 0) {
              if (sessionStorage.getItem("shopsetting_activeName")) {
                this.activeName = sessionStorage.getItem("shopsetting_activeName")
              } else {
                this.activeName = res.data.data[0].id_tostrign
              }
              this.$nextTick(() => {
                this.getlist()
              })
            } else {
              this.activeName = ''
              sessionStorage.removeItem('shopsetting_activeName')
            }
          },
          tip: () => {
          },
        })
      },
      handleClick(tab) {
        sessionStorage.setItem("shopsetting_activeName", tab.name)
        this.activeName = tab.name
        this.$nextTick(() => {
          this.getlist()
        })
      },
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/dear/location",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.warehouse = res.data
            this.refund_warehouse = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/dear/meContract",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.salesman = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/dear/customer",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.customer = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/dear/tax",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.tax_rate = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/dear/account",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.pay_account = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/dear/expressGoods",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.express_good = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/dear/revenueAccount",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.revenue_account = res.data
          },
          tip: () => { },
        })
        this.$post({
          url: "/app/order_attribute/attributeList",
          data: {
            shop_id: this.activeName
          },
          success: (res) => {
            if (!res) return
            let obj = JSON.parse(JSON.stringify(res.data))
            let arr = []
            for (let i in obj) {
              if (i.indexOf('attribute') !== -1) {
                arr.push({
                  name: i.replace('attribute', this.$t('lg.附加属性')),
                  id: i.split('attribute')[1],
                  value: obj[i]
                })
              }
            }
            this.order_header = arr
          },
          tip: () => {
          },
        })

        setTimeout(() => {
          this.getdata()
        }, 1200);
      },
      getdata() {
        this.$post({
          url: "/app/shop_config/info",
          data: {
            shop_id: this.activeName
          },
          success: res => {
            // this.$refs.forms.resetFields();
            this.$nextTick(() => {
              if (!res.data) return;
              this.form = {
                warehouse: res.data.warehouse,
                warehouse_id: res.data.warehouse_id,
                warehouse_key: res.data.warehouse_key,

                refund_warehouse: res.data.refund_warehouse,
                refund_warehouse_id: res.data.refund_warehouse_id,
                refund_warehouse_key: res.data.refund_warehouse_key,

                salesman: res.data.salesman,
                salesman_id: res.data.salesman_id,
                customer_name: res.data.customer_name,
                customer_id: res.data.customer_id,
                tax_rate: res.data.tax_rate,
                tax_id: res.data.tax_id,
                pay_account: res.data.pay_account,
                pay_account_code: res.data.pay_account_code,
                order_header: res.data.order_header,
                delivery_process: res.data.delivery_process,
                orders_to_dear: res.data.orders_to_dear,
                order_start_time: res.data.order_start_time,
                stock_to_erp: res.data.stock_to_erp,
                pick_pack: res.data.pick_pack,
                express_goods: res.data.express_goods,
                express_sale_tax_rule: res.data.express_sale_tax_rule,
                express_sale_tax_rule_id: res.data.express_sale_tax_rule_id,

                revenue_account: res.data.revenue_account,
                revenue_account_code: res.data.revenue_account_code,
                cny_rate: res.data.cny_rate,
              }
              // let warehouse_obj = this.warehouse.find(data => data.key == this.form.warehouse_key)
              // this.form.warehouse_id = warehouse_obj.id
              // let refund_warehouse_obj = this.warehouse.find(data => data.key == this.form.refund_warehouse_key)
              // this.form.refund_warehouse_id = refund_warehouse_obj ? refund_warehouse_obj.id : ''

              let salesman_obj = this.salesman.find(data => data.ContactID == this.form.salesman_id)
              this.form.salesman = salesman_obj ? salesman_obj.Name : ''
              let express_goods_obj = this.express_good.find(data => data.ID == this.form.express_sale_tax_rule_id)
              this.form.express_sale_tax_rule = express_goods_obj ? express_goods_obj.SaleTaxRule : ''

              if (this.form.delivery_process !== 1) {
                this.form.pick_pack = 0;
              }
            })

            this.loading = false
          },
          tip: () => {
            this.loading = false
            this.form = {
              warehouse: '',
              warehouse_id: '',
              warehouse_key: '',
              refund_warehouse: '',
              refund_warehouse_id: '',
              refund_warehouse_key: '',
              salesman: '',
              customer_name: '',
              customer_id: '',
              tax_rate: '',
              tax_id: '',
              pay_account: '',
              pay_account_code: '',
              order_header: '',
              delivery_process: '',
              orders_to_dear: '',
              stock_to_erp: '',
              pick_pack: '',
              order_start_time: '',
              express_goods: '',
              express_sale_tax_rule_id: '',
              express_sale_tax_rule: '',
              revenue_account: '',
              revenue_account_code: '',
              cny_rate: '',

            }
          },
        })
      },
      onSubmit() {
        this.$refs.forms.validate(valid => {
          if (valid) {
            let warehouse_obj = this.warehouse.find(data => data.id == this.form.warehouse_id)
            // this.form.warehouse_id = warehouse_obj.id
            this.form.warehouse = warehouse_obj?.name || ''
            let refund_warehouse_obj = this.warehouse.find(data => data.key == this.form.refund_warehouse_id)
            this.form.refund_warehouse = refund_warehouse_obj?.name || ''
            // this.form.refund_warehouse_id = refund_warehouse_obj.id
            let customer_name_obj = this.customer.find(data => data.ID == this.form.customer_id)
            this.form.customer_name = customer_name_obj?.Name || ''
            let salesman_obj = this.salesman.find(data => data.ContactID == this.form.salesman_id)
            this.form.salesman = salesman_obj?.Name || ''
            let tax_rate_obj = this.tax_rate.find(data => data.ID == this.form.tax_id)
            this.form.tax_rate = tax_rate_obj?.Name || ''
            let pay_account_obj = this.pay_account.find(data => data.Code == this.form.pay_account_code)
            this.form.pay_account = pay_account_obj?.Name || ''
            let express_goods_obj = this.express_good.find(data => data.ID == this.form.express_sale_tax_rule_id)
            this.form.express_goods = express_goods_obj?.express_goods || ''
            this.form.express_sale_tax_rule = express_goods_obj?.SaleTaxRule || ''
            let revenue_account_obj = this.revenue_account.find(data => data.Code == this.form.revenue_account_code)
            this.form.revenue_account = revenue_account_obj?.Name || ''

            console.log(12, this.form);
            this.btn_loading = true
            this.$post({
              url: "/app/shop_config/setConfig",
              data: {
                shop_id: this.activeName,
                ...this.form
              },
              success: (res) => {
                this.$message({
                  message: this.$t('lg.成功'),
                  type: 'success'
                });
                setTimeout(() => {
                  this.getdata()
                  this.btn_loading = false
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.btn_loading = false
                }, 1500);
              },
            })
          }
        });
      },
      save() {

        const loading = this.$loading({
          lock: true,
          color: '#19cbbe',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        // setTimeout(() => {
        //   loading.close();
        // }, 2000);

        this.btn_loading = true
        this.$post({
          url: "/app/goods/dearStockToErp",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.getdata()
              this.btn_loading = false
            }, 1500);
            setTimeout(() => {
              loading.close();
            }, 2000);
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loading = false
            }, 1500);
            setTimeout(() => {
              loading.close();
            }, 2000);
          },
        })
      },
    },
    mounted() {
    },
    created() {
      this.gettablist()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 10px 20px 0px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
      .headerbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #e4e7ed;
        /deep/.el-tabs {
          width: 90%;
          .el-tabs__header {
            margin: 0;
          }
          .el-tabs__nav-wrap::after {
            display: none;
          }
        }
        .topbtnbox {
          width: 10%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    .tablebox {
      width: 100%;
      padding: 30px 10px 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-select,
        .el-date-editor {
          width: 100%;
        }
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
    }
  }
  /deep/.el-loading-spinner .el-loading-text {
    color: #19cbbe;
    margin: 3px 0;
    font-size: 14px;
  }
  /deep/.el-loading-spinner i {
    color: #19cbbe;
  }
</style>